<template>
  <div>
    <label>Grupo de clientes</label>

    <div class="w3-row">
      <div class="w3-col s4 l2">
        <input
          type="text"
          @keyup.enter="inserirDadoPorChave(undefined)"
          ref="cliente"
          class="w3-input w3-border input-codigo"
          v-model="chave_pesquisa"
          :disabled="somenteLeitura == 'S'"
          v-bind:placeholder="placeholder_codigo"
          v-on:blur="verificarCampoPesquisa()"
          maxlength="15"/>
      </div>

      <div class="w3-col s8 l10">
        <div class="input-container">
          <input
            class="input-cliente w3-border"
            type="text"
            v-model="nome_exibicao"
            @click="abrirPesquisaGruposClientes"
            :disabled="somenteLeitura == 'S'"
            placeholder="Clique para selecionar o grupo de clientes"
            readonly>

          <i
            v-if="somenteLeitura == 'N'"
            class="fas fa-minus icone w3-border-top w3-border-right w3-border-bottom"
            @click="limparDados">
          </i>
        </div>
      </div>
    </div>

    <pesquisa-grupos-clientes
      ref="pesquisaGruposClientes"
      @confirmar="confirmarPesquisaGruposClientes">
    </pesquisa-grupos-clientes>
  </div>
</template>

<script>
  import toastr from 'toastr'
  import Biblioteca from '@/components/Repositorio/Biblioteca'
  import PesquisaGruposClientes from '@/components/Pesquisas/PesquisaGruposClientes'
  import RGrupoCliente from '@/components/Rest/RGrupoCliente'

  export default {
    name: 'FrameGrupoClientes',

    components: {
      toastr,
      PesquisaGruposClientes
    },

    props: {
      somenteLeitura: {
        required: true,
        type: String,
        default: 'N'
      },

      grupoClientesSelecionado: {
        required: false,
        type: Object,
        default: function () {
          return {}
        }
      }
    },

    data() {
      return {
        grupo_clientes_selecionado: {},
        nome_exibicao: '',
        chave_pesquisa: '',
        placeholder_codigo: 'Cód.'
      }
    },

    methods: {
      async inserirDadoPorChave(grupo_clientes_id) {
        try {
          let parametro = Biblioteca.valorInt(grupo_clientes_id);
          if (!parametro) {
            parametro = Biblioteca.valorInt(this.chave_pesquisa);
            if ((!parametro) || (parametro <= 0)) {
              toastr.error('Informe um código de grupo de clientes válido!');
              return;
            }
          }

          let parametros = {
            grupo_clientes_id: parametro
          }

          let retorno = await RGrupoCliente.buscarGrupoClientesPorId(this.axios, parametros);
          if (retorno.houve_erro != 'N') {
            throw new Error(retorno.mensagem);
          }

          this.confirmarPesquisaGruposClientes(JSON.parse(JSON.stringify(retorno.dados)));
        }
        catch (e) {
          this.limparDados();
          toastr.error(e.message);
        }
      },

      abrirPesquisaGruposClientes() {
        this.$refs.pesquisaGruposClientes.abrir();
      },

      confirmarPesquisaGruposClientes(origem) {
        this.grupo_clientes_selecionado = JSON.parse(JSON.stringify(origem));

        this.chave_pesquisa = '';
        this.placeholder_codigo = Biblioteca.nPadrao(this.grupo_clientes_selecionado.grupo_clientes_id, 0);
        this.nome_exibicao = this.grupo_clientes_selecionado.nome;
        
        this.$emit('confirmar', this.grupo_clientes_selecionado);
      },
     
      limparDados() {
        this.chave_pesquisa = '';
        this.placeholder_codigo = 'Cód.';
        this.nome_exibicao = '';
        this.grupo_clientes_selecionado = {};

        this.$emit('limparDados');
      },

      carregar(grupo_clientes) {
        if ((!grupo_clientes) || (!grupo_clientes.grupo_clientes_id)) {
          this.limparDados();
          return;
        }

        this.confirmarPesquisaGruposClientes(JSON.parse(JSON.stringify(grupo_clientes)));
      },

      valor(numero_str) {
        return Biblioteca.valor(numero_str);
      }
    },

    created() {
      if (this.grupoClientesSelecionado) {
        this.carregar(this.grupoClientesSelecionado);
      }
    }
  }
</script>

<style escoped>
  .card-item {
    background-color: #f3f3f3;
    border-radius: 10px;
    box-shadow: #f3f3f3 1px 3px 5px 3px ;
    margin-bottom: 5px;
    padding: 3px !important;
  }

  .input-codigo {
    padding: 10px 15px;
    border-radius: 0px;
    position: relative;
    z-index: 0;
    background: #fff;
    font-weight: bold;
  }

  .input-container {
    display: -ms-flexbox; 
    display: flex;
    position: relative;
    z-index: 1;
    margin-left: -20px;
    width: calc(100% + 20px);
  }

  .icone {
    padding: 11px;
    background: gray;
    color: white;
    min-width: 15px;
    text-align: center;
    border-left-style: none
  }

  .icone:active {
    background-color: #ccc;
    box-shadow: 0 1px #666;
    transform: translateY(1px);
  }

  .input-cliente {
    width: 100%;
    padding: 10px;
    outline: none;
    cursor: pointer;
    font-weight: bold;
    border-right-style: none;
  }

</style>





// WEBPACK FOOTER //
// src/components/Frames/FrameGrupoClientes.vue